import {Event, EventTypeAirports, EventTypeRoute} from "../types/domain";

export const isRouteEvent = (event: Event): event is Event & EventTypeRoute =>
    event.type === 'route';

export const isAirportsEvent = (event: Event): event is Event & EventTypeAirports =>
    event.type === 'airports';